import { render, staticRenderFns } from "./StudentSearch.vue?vue&type=template&id=675695f1&scoped=true&"
import script from "./StudentSearch.vue?vue&type=script&lang=js&"
export * from "./StudentSearch.vue?vue&type=script&lang=js&"
import style0 from "./StudentSearch.vue?vue&type=style&index=0&id=675695f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675695f1",
  null
  
)

export default component.exports